import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {FormField} from '../form/form-field';
import {Radio} from '../radio/radio';
import {RadioGroup} from '../radio/radio-group';
import type {SavedSettingToastState} from '../saved-setting-toast/saved-setting-toast';

type OwnProps = {
    title: string;
    subtitle?: string | React.ReactNode;
    options: {
        value: string;
        title: string;
    }[];
    isRequired?: boolean;
    labelIsTwoLines?: boolean;
    saveToastState?: SavedSettingToastState;
    errorMessage?: string;
};

type Props = FieldProps & OwnProps;

export function ReduxFormRadioGroup(props: Props) {
    return (
        <FormField
            innerId={props.input.name}
            label={props.title}
            sublabel={props.subtitle}
            errorMessage={
                props.errorMessage ||
                (props.meta.error && props.meta.submitFailed ? props.meta.error : null)
            }
            isRequired={props.isRequired}
            labelIsTwoLines={props.labelIsTwoLines}
            saveToastState={props.saveToastState}
        >
            <RadioGroup
                name={props.input.name}
                selectedValue={props.input.value}
                onChange={props.input.onChange}
            >
                {/* @ts-expect-error */}
                {props.options.map((option) => {
                    return (
                        <Radio key={option.value} value={option.value}>
                            {option.title}
                        </Radio>
                    );
                })}
            </RadioGroup>
        </FormField>
    );
}
